/**
 * Glas-Tab-Bar. Fünf Tabs: Heute / Kurs / Coach / Bibliothek / Profil.
 *
 * Der Coach-Tab (Mitte) ist KEIN Routenwechsel, sondern ein Toggle: er öffnet/
 * schließt den Coach als Overlay-Sheet über dem aktuellen Inhalt (Auftraggeber-
 * Entscheidung T3.6 — Bubble/FAB entfällt). Trainer-Statistik liegt jetzt im Profil,
 * damit die Leiste bei fünf Tabs bleibt. Touch-Targets ≥ 44 px.
 */
import type { ComponentType } from "preact";
import { useLocation } from "preact-iso";
import { dock, toggleCoach } from "../state/coach";
import {
  IconHome,
  IconBook,
  IconSparkles,
  IconLibrary,
  IconUser,
} from "./icons";

interface Tab {
  label: string;
  Icon: ComponentType<{ size?: number }>;
  href?: string; // Routen-Tab
  coach?: boolean; // Coach-Toggle-Tab (Overlay statt Route)
}

const TABS: Tab[] = [
  { href: "/", label: "Start", Icon: IconHome },
  { href: "/kurs", label: "Kurs", Icon: IconBook },
  { coach: true, label: "Coach", Icon: IconSparkles },
  { href: "/bibliothek", label: "Bibliothek", Icon: IconLibrary },
  { href: "/profil", label: "Profil", Icon: IconUser },
];

export function TabBar() {
  const { path, route } = useLocation();
  const coachOpen = dock.value === "sheet";

  function isActive(t: Tab): boolean {
    if (t.coach) return coachOpen;
    if (t.href === "/") return path === "/";
    return !!t.href && path.startsWith(t.href);
  }

  return (
    <nav class="tabbar" aria-label="Hauptnavigation">
      {TABS.map((t) => {
        const active = isActive(t);
        const key = t.coach ? "coach" : t.href;
        return (
          <button
            key={key}
            class={`tabbar__item${active ? " is-active" : ""}${t.coach ? " tabbar__item--coach" : ""}`}
            aria-current={active ? "page" : undefined}
            aria-label={t.coach ? "KI-Coach öffnen oder schließen" : undefined}
            onClick={() => (t.coach ? toggleCoach() : route(t.href!))}
          >
            <span class="tabbar__icon">
              <t.Icon size={22} />
            </span>
            <span class="tabbar__label">{t.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
